<template>
	<div class="l-container works">
		<div class="recently-project-wrap">
			<h1 class="page-tit">Visual Marketing</h1>
			<!-- Thumbnail View : s -->
			<div class="view-area">
				<div class="is-active">
					<div class="select-box-wrap" :class="{ 'align-r': !viewType }">
						<div class="select-box tab">
							<div class="swiper-container tab-swiper">
								<ul class="swiper-wrapper">
									<li class="swiper-slide is-active">
										<a href="javascript:;" @click="sortingList('All', $event)"
											>All</a
										>
									</li>
									<li class="swiper-slide" v-show="viewType">
										<a
											href="javascript:;"
											@click="sortingList('Proposal', $event)"
											>Proposal</a
										>
									</li>
									<li class="swiper-slide" v-show="viewType">
										<a
											href="javascript:;"
											@click="sortingList('Presentation', $event)"
											>Presentation</a
										>
									</li>
								</ul>
							</div>
						</div>
						<div class="select-type">
							<button
								@click="selectViewType('thumbnail')"
								:class="{ 'is-active': viewType }"
							>
								<span class="type-thumb">썸네일타입</span>
							</button>
							<button
								@click="selectViewType('list')"
								:class="{ 'is-active': !viewType }"
							>
								<span class="type-list">리스트</span>
							</button>
						</div>
					</div>
					<div v-if="viewType">
						<div class="recently-project" v-if="ptSize">
							<ul>
								<li
									v-for="(pt, index) in ptCurrent"
									:key="index"
									:data-category="pt.category"
								>
									<router-link
										v-bind:to="`/visual-marketing/${pt.ptUrl}`"
										class="user"
									>
										<img
											v-lazy="pt.thumbImg"
											:alt="pt.thumbImgAlt"
											v-if="lazyOK"
										/>
										<img :src="pt.thumbImg" :alt="pt.thumbImgAlt" v-else />
										<p>
											<strong class="tit" v-html="pt.thumbTitle"></strong>
										</p>
									</router-link>
								</li>
							</ul>
						</div>
						<div class="message" v-else>해당하는 프로젝트가 없습니다.</div>
					</div>
					<ul class="presentation-table" v-else>
						<li>
							<strong>인천아시아경기대회조직위원회</strong>
							<div>인천아시아경기대회 홍보 PT 및 마케팅 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>인천아시아경기대회조직위원회</strong>
							<div>올림픽 총회, 파이널 보고, 분과위 보고 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>인천장애인아시아경기대회조직위원회</strong>
							<div>
								2014인천장애인아시아경기대회 홍보 및 VIP PT 컨설팅 외 다수
							</div>
						</li>
						<li>
							<strong>한국전력공사</strong>
							<div>IR, 홍보, 경진대회 PT 디자인 및 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>한국남부발전</strong>
							<div>
								Cyber Ware House Master Plan, 인사제도 혁신 PT 컨설팅 외 다수
							</div>
						</li>
						<li>
							<strong>환경관리</strong>
							<div>공공하수처리시설 경쟁입찰 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>포스코건설</strong>
							<div>건설안전 우수사례 경진대회 PT 컨설팅 외 2건</div>
						</li>
						<li>
							<strong>삼성엔지니어링</strong>
							<div>건설안전 우수사례 경진대회 PT 컨설팅</div>
						</li>
						<li>
							<strong>국토교통부</strong>
							<div>국가 물류시설 선진화 홍보 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>웅진씽크빅</strong>
							<div>
								웅진씽크빅 컴퓨터스쿨 경쟁입찰 표준제안 및 경쟁입찰 컨설팅 외
								다수
							</div>
						</li>
						<li>
							<strong>MANDO</strong>
							<div>해외 VIP 바이어 대상 홍보 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>삼지전자</strong>
							<div>방송통신위원회 OIDD 경쟁입찰 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>메타넷 MCC</strong>
							<div>
								국민은행, BMW, 메츠라이프, 한국전력, 유니세프 등 경쟁입찰 컨설팅
								외 다수
							</div>
						</li>
						<li>
							<strong>MPC</strong>
							<div>
								현대자동차, 국민건강보험, 국민연금 등 경쟁입찰 컨설팅 외 다수
							</div>
						</li>
						<li>
							<strong>한국철도기술연구원</strong>
							<div>실시간 철도안전 통합제어시스템 개발 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>한국가스공사</strong>
							<div>연료전시 홍보 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>올레 KT</strong>
							<div>서울전략사업 경쟁입찰 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>인천시청</strong>
							<div>경제자유구역 투자유치 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>선우정밀</strong>
							<div>
								지속가능경영보고 컨설팅, 안전보공공단 위험성평가 PT 컨설팅 외
								다수
							</div>
						</li>
						<li>
							<strong>공항시설관리</strong>
							<div>인천공항 경쟁입찰 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>장형기업</strong>
							<div>
								노사문화 우수기업, 지속경영가능보고서 컨설팅, 경쟁입찰 컨설팅 외
								다수
							</div>
						</li>
						<li>
							<strong>인프라개발</strong>
							<div>영남권국가물류터미널 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>농촌진흥청</strong>
							<div>제2세대 바이오그린21 수주 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>윌앤비전</strong>
							<div>
								아시아나항공, 한국전력, 하이마트, 중소기업유통센터 경쟁입찰
								컨설팅 외 다수
							</div>
						</li>
						<li>
							<strong>동부건설</strong>
							<div>인천 집단에너지시설 경쟁입찰 PT 컨설팅</div>
						</li>
						<li>
							<strong>미시간랭귀지</strong>
							<div>삼성전자 외국어교육 경쟁입찰 컨설팅</div>
						</li>
						<li>
							<strong>IBS 인더스트리</strong>
							<div>
								서울파이낸스센터, 인천공항공사, 국민은행, 센터1경쟁입찰 컨설팅
								외 다수
							</div>
						</li>
						<li>
							<strong>태가BM</strong>
							<div>신촌세브란스병원, 고대안암병원 경쟁입찰 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>건국대학교</strong>
							<div>PRIME 사업 홍보 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>부일정보링크</strong>
							<div>한국교직원공제회 경쟁입찰 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>토스</strong>
							<div>KAKAO 뱅크 경쟁입찰 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>인천도시공사</strong>
							<div>상해 크루즈 홍보 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>LB휴넷</strong>
							<div>AIA생명 경쟁입찰 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>대성글로벌네트웍</strong>
							<div>고용노동부, 국민건강보험 경쟁입찰 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>MMK</strong>
							<div>
								한국얀센, 중외제약, 동아제약 경쟁입찰 PT 컨설팅 및 디자인 외
								다수
							</div>
						</li>
						<li>
							<strong>서울시청</strong>
							<div>해외 관광 마케팅, 교통편의시스템 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>자동차융합기술원</strong>
							<div>상용차산업 혁신성장 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>한국현금결제</strong>
							<div>B2B 현금결제시스템 “바로패스” 홍보 PT 컨설팅</div>
						</li>
						<li>
							<strong>충청남도청</strong>
							<div>충청남도 신속집행 및 추경편성계획 PT 외 컨설팅 다수</div>
						</li>
						<li>
							<strong>스카이네트웍스</strong>
							<div>벤츠 CS Clinic Report / 온사이트 보고서 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>전라북도청</strong>
							<div>전라북도 고용안정 선제대응 패키지 구축사업 PT 컨설팅</div>
						</li>
						<li>
							<strong>신한신용정보</strong>
							<div>한국자산관리공사 경쟁입찰 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>거창</strong>
							<div>한국에너지관리공단 경쟁입찰 PT 컨설팅 외 다수</div>
						</li>
						<li>
							<strong>군산자동차무역센터</strong>
							<div>
								군산시 새만금 자동차 수출복합센터 조성사업 경쟁입찰 컨설팅
							</div>
						</li>
					</ul>
				</div>
				<!-- Thumbnail View : e -->
			</div>
		</div>
		<br />
		<router-view></router-view>
	</div>
</template>

<style>
@import "../../static/css/swiper.min.css"; /* if use swiper.min.js */
@import "../../static/css/jquery-ui.min.css"; /* if use swiper.min.js */
</style>
<script>
import { store } from "../data/store.js";
import Swiper from "../../static/js/swiper.min.js"; /* if use swiper.min.js */
export default {
	data() {
		return {
			store,
			ptCurrent: {},
			viewType: true,
			lazyOK: true,
			ptSize: true,
		};
	},
	methods: {
		sortingList(category, event) {
			category = category.toLowerCase();
			if (category != "all") {
				this.ptCurrent = this.store.bsd.filter(
					(v) => v.category.toLowerCase() == category
				);
				this.lazyOK = false;
			} else {
				this.ptCurrent = this.store.bsd;
				this.lazyOK = true;
			}

			this.ptSize = this.ptCurrent.length == 0 ? false : true;

			let $siblings = Array.prototype.slice.call(
				event.currentTarget.closest(".swiper-wrapper").children
			);

			$siblings.forEach(function (el) {
				el.classList.remove("is-active");
			});
			event.currentTarget.parentNode.classList.add("is-active");
		},
		selectViewType(type) {
			this.viewType = type == "thumbnail" ? true : false;
		},
	},
	mounted() {
		// mobile tab menu swiper control
		var $window = $(window);
		var winW = $window.outerWidth();
		var flag = true;
		var isSlider = true;
		var pcwebSwiper;

		var pcWeb = function () {
			if (isSlider) {
				isSlider = false;
				pcwebSwiper = new Swiper(".tab-swiper", {
					slidesPerView: "auto",
					spaceBetween: 20,
					grabCursor: true,
					loop: false,
					slideToClickedSlide: true,
				});
			}
		};

		winW = $window.outerWidth();
		if (winW < 712) {
			pcWeb();
		} else {
			isSlider = true;
		}

		$window.on("resize", function () {
			winW = $window.outerWidth();
			if (winW < 712) {
				if (flag) {
					flag = false;
					pcWeb();
				}
			} else {
				flag = true;
				if (!isSlider) {
					isSlider = true;
					pcwebSwiper.destroy();
				}
			}
		});
	},
	created() {
		this.ptCurrent = this.store.bsd;
		console.log("xgPresentation");
	},
};
</script>

<style scoped>
.select-box-wrap {
	display: flex;
	justify-content: space-between;
}
.select-box-wrap.align-r {
	justify-content: flex-end;
}
.select-box-wrap.align-r .swiper-slide:first-child {
	padding-bottom: 4px;
	border-bottom: 1px solid #ff4911;
}
.select-box-wrap.align-r .swiper-slide:first-child:before {
	content: "";
	position: absolute;
	top: 0;
	right: 0;
	left: 0;
	bottom: 0;
	background-color: transparent;
}
.presentation-table {
	display: block;
	padding: 30px 15px;
	border-top: 1px solid #bcbcbc;
	background-color: #fff;
}
.presentation-table li {
	min-height: 150px;
	padding-top: 27px;
	padding-bottom: 28px;
	color: #222;
	border-bottom: 1px solid #bcbcbc;
	line-height: 1.5;
}
.presentation-table li > strong {
	display: block;
	margin-bottom: 14px;
	font-size: 2.2rem;
	font-weight: bold;
}
.presentation-table li > div {
	font-size: 1.6rem;
}
.select-type button + button {
	margin-left: 28px;
}
.select-type button span {
	overflow: hidden;
	display: inline-block;
	width: 32px;
	height: 32px;
	background: url(/static/img/sorting.png) no-repeat;
	background-size: 65px;
	text-indent: 100%;
	white-space: nowrap;
}
.select-type .type-thumb {
	background-position: 0 0;
}
.select-type .is-active .type-thumb {
	background-position: 0 100%;
}
.select-type .type-list {
	background-position: 100% 0;
}
.select-type .is-active .type-list {
	background-position: 100% 100%;
}
.select-type {
	display: flex;
	justify-content: center;
	width: 100%;
}
.select-box-wrap {
	align-items: center;
	margin-bottom: 25px;
}
@media screen and (min-width: 713px) {
	.select-type {
		display: inline-flex;
		width: 92px;
	}
	.select-box-wrap {
		margin-bottom: 35px;
	}
	.presentation-table {
		display: flex;
		flex-wrap: wrap;
		width: 100%;
		padding: 30px;
		border-top: none;
	}
	.presentation-table li {
		padding-top: 24px;
		padding-bottom: 26px;
	}

	@media screen and (max-width: 1279px) {
		.presentation-table li > div {
			font-size: 1.8rem;
		}
		.presentation-table li:nth-child(1),
		.presentation-table li:nth-child(2) {
			border-top: 1px solid #bcbcbc;
		}
		.presentation-table > li {
			flex: 0 0 calc(50% - 30px);
		}
		.presentation-table > li:nth-child(2n + 2) {
			margin-left: 60px;
		}
	}
	@media screen and (min-width: 1280px) {
		.works .select-box-wrap .tab li.is-active {
			padding-bottom: 7px;
			border-bottom: 2px solid #ff4911;
		}
		.select-box-wrap.align-r .swiper-slide:first-child {
			font-weight: 800;
		}
		.presentation-table {
			padding: 40px;
		}
		.presentation-table > li {
			flex: 0 0 calc(33% - 54px);
			min-height: 170px;
			padding-top: 33px;
			padding-bottom: 36px;
		}
		.presentation-table li:nth-child(1),
		.presentation-table li:nth-child(2),
		.presentation-table li:nth-child(3) {
			border-top: 1px solid #bcbcbc;
		}
		.presentation-table > li:not(:nth-child(3n + 1)) {
			margin-left: 80px;
		}

		.presentation-table li > strong {
			margin-bottom: 6px;
			font-size: 3rem;
		}
		.presentation-table li > div {
			font-size: 1.8rem;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/XgBSD.vue